"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasRendererFactory = void 0;
/**
 * @public
 * Canvas {@link IComponentRendererFactory}.
 */
class CanvasRendererFactory {
    constructor(componentRenderer) {
        this.componentRenderer = componentRenderer;
    }
    createRenderer() {
        return this.componentRenderer;
    }
}
exports.CanvasRendererFactory = CanvasRendererFactory;
//# sourceMappingURL=canvas-renderer-factory.js.map